export var defaultGridProps = {
    className: '',
};
export var defaultRowProps = {
    className: '',
    gutter: 0,
};
export var defaultColProps = {
    className: '',
    col: 0,
    offset: -1,
};
